 import { useEffect } from 'react';
 import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useSelector, useDispatch } from 'react-redux'


const Toast = () => {
    const usuario = useSelector((state) => state.usuario)
	useEffect(() => {
		
        if(usuario.toast_msj.cont!="" && usuario.toast_msj.tipo==="success"){
            console.log(usuario.toast_msj)
            toast.success(usuario.toast_msj.cont, {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "dark",
                });
        }else if(usuario.toast_msj.cont!="" && usuario.toast_msj.tipo==="success"){
            console.log(usuario.toast_msj)
            toast.warning(usuario.toast_msj.cont, {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "dark",
                });
        }
	}, [usuario.toast_msj.time]);
    
    return <ToastContainer />
}

export default Toast